<template>
  <div>
    <div
      :class="{ active: isActive }"
      class="sidebar-item"
      @click="handleClick">
      <span>{{ item.label }}</span>

      <v-chip
        v-if="typeof item.count === 'number'"
        size="small"
        density="compact"
        rounded="pill">
        {{ item.count }}
      </v-chip>

      <v-icon
        v-if="hasChildren"
        :key="isOpen"
        size="x-small"
        transition="fade-transition">
        {{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
      </v-icon>
    </div>

    <transition name="collapse">
      <div v-if="hasChildren && isOpen" class="children">
        <SidebarListItem
          v-for="(child, i) in item.children"
          :key="i"
          :item="child" />
      </div>
    </transition>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import { computed, ref, watch } from 'vue'

export default {
  name: 'SidebarListItem',
  props: {
    item: { type: Object, required: true },
  },
  setup(props) {
    const route = useRoute()
    const router = useRouter()

    const isOpen = ref(!!props.item.defaultOpen)

    const hasChildren = computed(() => {
      return props.item.children && props.item.children.length
    })

    const isActive = computed(() => {
      return isItemActive(props.item)
    })

    const isChildActive = computed(() => {
      const check = items => {
        return items?.some(child => {
          if (isItemActive(child)) return true

          if (child.children) {
            return check(child.children)
          }

          return false
        })
      }

      return check(props.item.children)
    })

    const isItemActive = item => {
      if (!item.to) return false

      if (typeof item.to === 'object') {
        const { name, params, query } = item.to

        if (query) {
          if (route.name !== name) return false

          return Object.entries(query).every(([key, value]) => {
            return String(route.query[key]) === String(value)
          })
        }

        if (!route.matched.some(r => r.name === name)) return false

        if (params?.id) {
          return Number(route.params.id) === Number(params.id)
        }

        return true
      }

      return route.matched.some(r => r.name === item.to)
    }

    watch(
      isChildActive,
      val => {
        if (val || props.item.defaultOpen) isOpen.value = true
      },
      { immediate: true }
    )

    const handleClick = () => {
      if (hasChildren.value) {
        isOpen.value = !isOpen.value
        return
      }

      if (props.item.to) {
        router.push(props.item.to)
      }
    }

    return {
      isOpen,
      hasChildren,
      isActive,
      isChildActive,
      handleClick,
    }
  },
}
</script>

<style lang="scss" scoped>
.sidebar-item {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 5px 12px;
  border-radius: 12px;
  color: #4a4a55;
  font-size: 15px;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background: #eef2f7;
  }

  &.active {
    background: #dbe7f3;
    color: #2563eb;
    font-weight: 500;
  }
}

/* вложенность */
.children {
  margin-left: 15px;
  margin-top: 3px;
}

.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.25s ease;
  overflow: hidden;
}

.collapse-enter-from,
.collapse-leave-to {
  max-height: 0;
  opacity: 0;
}

.collapse-enter-to,
.collapse-leave-from {
  max-height: 500px;
  opacity: 1;
}
</style>
